import {
  EsignFieldKind,
  type PublicSignerSessionResponse,
  type PublicSignerSubmitRequest
} from '../publicSignerTypes';

import {
  getCheckboxFieldValue,
  getRadioGroupFieldValue,
  getSignatureFieldValue,
  getTextFieldValue,
  isFieldEditable,
  isSignatureEntryField
} from './fieldValue';
import type { PublicSignerFieldDraftValues } from './types';

export function buildPublicSignerSubmitRequest(
  session: PublicSignerSessionResponse,
  fieldDraftValues: PublicSignerFieldDraftValues,
  isDisclosureAccepted: boolean
): PublicSignerSubmitRequest {
  const hasSignatureEntryValues = session.fields.some(
    (field) =>
      isFieldEditable(field) &&
      isSignatureEntryField(field) &&
      Boolean(getSignatureFieldValue(fieldDraftValues[field.id]))
  );

  return {
    ...(hasSignatureEntryValues && isDisclosureAccepted
      ? { disclosure_accepted: true }
      : {}),
    fields: session.fields.filter(isFieldEditable).map((field) => {
      const draftValue = fieldDraftValues[field.id];

      if (field.field_kind === EsignFieldKind.Checkbox) {
        return {
          field_id: field.id,
          field_kind: EsignFieldKind.Checkbox,
          value: getCheckboxFieldValue(draftValue)
        };
      }

      if (isSignatureEntryField(field)) {
        return {
          field_id: field.id,
          field_kind: field.field_kind,
          value: getSignatureFieldValue(draftValue)
        };
      }

      if (field.field_kind === EsignFieldKind.RadioGroup) {
        return {
          field_id: field.id,
          field_kind: EsignFieldKind.RadioGroup,
          value: getRadioGroupFieldValue(draftValue)
        };
      }

      const nextValue = getTextFieldValue(draftValue);

      return {
        field_id: field.id,
        field_kind: EsignFieldKind.Text,
        value: nextValue.trim() ? nextValue : null
      };
    })
  };
}
